import React from 'react';
import SelectFieldCheckbox from './SelectFieldCheckbox';
import LookupItemService from '../../../../Services/LookupItemService';
import ErrorMessage from '../../../ErrorMessage';

export default class TrueFalseLookupItemSelect extends React.Component {
  static defaultProps = {
    value: null,
    className: 'w-100 form-control form-control-sm',
    filterCleared: false,
    fieldName: 'defaultFieldname',
    onChange: () => {},
    lookupId: null,
  };

  constructor(props) {
    super(props);
    this.state = {
      selectValues: [],
    };
  }

  componentDidMount() {
    this.populateListData();
  }

  populateListData() {
    if (!this.props.lookupId) {
      this.setState({ selectValues: [] });
      return;
    }

    LookupItemService.GetLookupItemListByLookupId(this.props.lookupId)
      .then((result) => {
        const optValues = [{ label: 'Choose one...', value: '', disabled: false }];
        result.forEach((lookupItem) => {
          optValues.push({
            label: lookupItem.text,
            value: lookupItem.value === 'True',
            disabled: false,
          });
        });
        this.setState({ selectValues: optValues });
      })
      .catch(() => {
        this.setState({ selectValues: [] });
        ErrorMessage.SetErrorMessage('TFLIS47');
      });
  }

  render() {
    return (
      <SelectFieldCheckbox
        value={this.props.value}
        className={this.props.className}
        fieldName={this.props.fieldName}
        onChange={this.props.onChange}
        filterCleared={this.props.filterCleared}
        selectValues={this.state.selectValues}
      />
    );
  }
}
